import React, { useState } from "react";

import PlaceholderSelector from "./PlaceholderSelector";

// Importar o componente PlaceholderSelector (copie o código do componente anterior aqui)
// Para fins de demonstração, vou incluir o componente inline

// Componente de exemplo de uso
export default function EmailConfig({
  onChangeSubject,
  onChangeBody,
  subjectValue,
  bodyValue,
}) {
  const [emailSubject, setEmailSubject] = useState(subjectValue ?? "");
  const [emailBody, setEmailBody] = useState(bodyValue ?? "");

  function handleSubjectChange(newSubject) {
    setEmailSubject(newSubject);

    if (!!onChangeSubject) {
      onChangeSubject(newSubject);
    }
  }

  function handleBodyChange(newBody) {
    setEmailBody(newBody);

    if (!!onChangeBody) {
      onChangeBody(newBody);
    }
  }

  return (
    <div
      style={{
        padding: "40px",
        maxWidth: "800px",
        margin: "0 auto",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      <h1 style={{ marginBottom: "32px", color: "#333" }}>
        Configuração de E-mail Automático
      </h1>

      <div style={{ marginBottom: "32px" }}>
        <h2 style={{ fontSize: "20px", marginBottom: "16px", color: "#555" }}>
          Configurar Modelo de E-mail
        </h2>

        <div style={{ marginBottom: "24px" }}>
          <PlaceholderSelector
            label="Assunto do E-mail"
            value={emailSubject}
            onChange={handleSubjectChange}
            placeholder="Digite o assunto do e-mail..."
          />
        </div>

        <div style={{ marginBottom: "24px" }}>
          <PlaceholderSelector
            label="Corpo do E-mail"
            value={emailBody}
            onChange={handleBodyChange}
            placeholder="Digite o conteúdo do e-mail..."
          />
        </div>
      </div>

      <div
        style={{
          backgroundColor: "#f5f7fa",
          padding: "24px",
          borderRadius: "8px",
          border: "1px solid #e1e4e8",
        }}
      >
        <h3 style={{ marginBottom: "16px", color: "#555" }}>
          Prévia do E-mail
        </h3>

        <div
          style={{
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "4px",
            border: "1px solid #e1e4e8",
          }}
        >
          <div style={{ marginBottom: "16px" }}>
            <strong>Assunto:</strong>
            <div
              style={{
                marginTop: "8px",
                padding: "8px 12px",
                backgroundColor: "#f8f9fa",
                borderRadius: "4px",
                fontFamily: "monospace",
                fontSize: "14px",
              }}
            >
              {emailSubject || "(vazio)"}
            </div>
          </div>

          <div>
            <strong>Corpo:</strong>
            <div
              style={{
                marginTop: "8px",
                padding: "12px",
                backgroundColor: "#f8f9fa",
                borderRadius: "4px",
                whiteSpace: "pre-wrap",
                fontFamily: "monospace",
                fontSize: "14px",
              }}
            >
              {emailBody || "(vazio)"}
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: "32px",
          padding: "16px",
          backgroundColor: "#e3f2fd",
          borderRadius: "4px",
          fontSize: "14px",
          color: "#1565c0",
        }}
      >
        <strong>💡 Dica:</strong> Clique no botão verde + para adicionar
        placeholders dinâmicos ao seu template de e-mail. Os placeholders serão
        substituídos automaticamente pelos valores reais quando o e-mail for
        enviado. O popup fecha automaticamente ao clicar fora dele ou ao
        selecionar um placeholder.
      </div>
    </div>
  );
}
